import { usePagination, useSorting } from "@/hooks";
import { GetNetworkParams } from "@/redux/apis/network/types";

export const useGetNetworkParams = () => {
  const { page, pageSize } = usePagination();
  const { sortKey, direction } = useSorting();

  const params: GetNetworkParams = {
    page,
    page_size: pageSize,
    sort: sortKey,
    direction,
  };

  return { params, page, pageSize, sort: sortKey, direction };
};
